export enum AllIcons {
  TOURAIKA = 'touraika',
  CROSS = 'cross',
  ARROWS = 'arrows',
  CALENDAR = 'calendar',
  PERSON = 'person',
  ARROWS_BOLD = 'arrows-bold',

  ARROW_RIGHT = 'arrow-right',
  ARROW_LEFT = 'arrow-left',
  MAGNIFIER = 'magnifier',
  CROSS_BOLD = 'cross-bold',
  PIN = 'pin',
  PLANE = 'plane',

  BAGGAGE = 'baggage',
  CBAGGAGE = 'cbaggage',
  BAGGAGE_DISABLED = 'baggage_disabled',
  CBAGGAGE_DISABLED = 'cbaggage_disabled',

  EXCHANGE = 'exchange',
  REFOUND = 'refund',
  BAGGAGE_CROSS = 'baggage_cross',
  LUGGAGE_CROSS = 'luggage_cross',
  CLOSE = 'close',
  CLOSE_BOLD = 'close_bold',
  INFO = 'info',
  PERSON_FLY = 'person_fly',
  PLUS = 'plus',
  MINUS = 'minus',
  CHECK_MARK = 'check-mark',
  FILTER = 'filter',
  ARROW_BOTTOM = 'arrow-bottom',
  SEARCH = 'search',
  NEW_SEARCH = 'new_search',
  NEW_SEARCH_INACTIVE = 'new_search_inactive',

  NEW_TICKET = 'new_ticket',
  NEW_TICKET_INACTIVE = 'new_ticket_inactive',
  NEW_PERSON = 'new_person',
  NEW_PERSON_INACTIVE = 'new_person_inactive',

  TICKET = 'ticket',
  MOON = 'moon',
  TICK_BOLD = 'tick-bold',
  REMOVE = 'remove',
  PERSONS = 'persons',
  DIFFICULT_ROUTE = 'difficult-route',
  QUESTION = 'question',
  OPPORTUNITY = 'opportunity',
  ADVANTAGES = 'advantages',
  CHARTER = 'charter',
  DISCOUNT = 'discount',
  ARROW_SHORT = 'arrow-short',
  WARNING = 'warning',
  ROYAL = 'royal',
  INFO_CALENDAR = 'info_calendar',
  LOOP = 'loop',
  ARROW_RIGHT_TARIFF = 'arrow-right-tariff',
  SHARE = 'share',
  PASSPORT_SCAN = 'passport-scan',
  INFO_BOLD = 'info-bold',
  AIRPLANE = 'airplane',
  MOUNTAIN = 'mountain',
  HOTEL = 'hotel',
  BURGER = 'burger',
  GROUP_STROKE = 'group-stroke',
  INSURANCE = 'insurance',
  TRAVEL_INSURANCE = 'travel-insurance',
  CHAT_FEEDBACK = 'chat-feedback',
  FAQ = 'faq',
  POLICY = 'policy',
  LANGUAGE = 'language',
  AVATAR_WOMAN = 'avatar-woman',
  AVATAR_MAN = 'avatar-man',
  COPY = 'copy',
  CASH = 'cash',
  MPLUS = 'mplus',
  MEAL = 'meal',
  MEAL_DISABLED = 'meal_off',
  PIECE = 'piece',
  PIECE_DISABLED = 'piece_off',
  MOON_NEW = 'moon_new',
  TRANSFER = 'transfer',
  PROMOTIONS = 'promotions',
  COPY_PROMO = 'copy_promo',
  APPEAL = 'appeal',
  CIRCLE_LINE = 'circle_line',
  VAN = 'van',
  BUS = 'bus',
  CHECK_ROUNDED = 'check_rounded',
  INFO_ROUNDED = 'info_rounded',
  PATH = 'path',
  FOOTBALL = 'football',

  COPY_NEW = 'copy_new',
  CHECKED_MY_ORDERS = 'checked_my_orders',
  CROSS_NEW = 'cross_new',
  AIRLINE_RATING = 'airline_rating',
  BOOKMARK_ORDERS = 'bookmark_my_orders',
  INFO_CIRCLE = 'info_circle',
  DONE_MY_ORDERS = 'done_my_orders',
  CALENDAR_NEW = 'calendar_new',
  MOON_ICON_INPUT = 'moon_icon_input',
  PEOPLE_NEW_INPUT = 'people_new_input',
  INFO_TOURS = 'info_tours',
  BEACH_LINE = 'beach_line',
  BEACH = 'beach',
  POOL_INCLUDE = 'pool_include',
  WIFI = 'wifi',
  STAR_FILLED = 'star_filled',
  STAR_FILLED_GOLD = 'star-filled-gold',
  STAR_OUTLINE = 'star_outline',
  LOGO = 'logo',
  LIKE = 'like',
  PASSENGERS = 'passengers',

  // TOURS - icons
  HALAL = 'halal',
  LOVE = 'love',
  DOOR = 'door',
  TIE = 'tie',
  BALL = 'ball',
  HEART = 'heart',
  FAMILY = 'family',
  INSURANCE_TOUR = 'insurance-tour',
  WATER_POOL = 'water-pool',
  SMALL_HOUSE = 'small-house',
  SWIMMING = 'swimming',
  BACKPACK = 'backpack',
  MEAL_TOUR = 'meal-tour',
  HOTEL_TOUR = 'hotel-tour',
  TENNIS = 'tennis',
  BICYCLE = 'bicycle',
  SAFE = 'safe',
  PET = 'pet',
  BEACH_TOUR = 'beach-tour',
  PLANE_TOUR = 'plane-tour',
  WIFI_TOUR = 'wifi-tour',
  DISTANCE_BEACH = 'distance-beach',
  AIRPLANE_2 = 'airplane_2',
  CHAT = 'chat',
  CHILD = 'child',
  EARTH = 'earth',
  LOAD_SCAN_IMG = 'load_scan_img',
  MINUS_BOLD = 'minus_bold',
  PLUS_BOLD = 'plus_bold',
  DOUBLE_BED = 'double-bed',
  IRON = 'iron',
  ROBE = 'robe',
  FAN = 'fan',
  FAN_2 = 'fan-2',
  COFFEE_CUP = 'coffee-cup',
  SWIM = 'swim',
  JACUZZI = 'jacuzzi',
  SLIPPERS = 'slippers',
  KETTLE = 'kettle',
  COCKTAIL = 'cocktail',
  FACADE = 'facade',
  BICYCLE_TOUR = 'bicycle-tour',
  ELECTRIC_KETTLE = 'electric-kettle',
  WINE = 'wine',
  WASHING_MACHINE = 'washing-machine',
  SHOWER = 'shower',
  KITCHEN = 'kitchen',
  FRIDGE = 'fridge',
  BATHROBE = 'bathrobe',
  TV = 'tv',
  HAIR_DRYER = 'hair-dryer',
  SAFE_TOUR = 'safe-tour',
  GLASS = 'glass',
  BEACH_BAG = 'beach-bag',
  SHARE_TOUR = 'share-tour',
  ARROW_RIGHT_LONG = 'arrow-right-long',
  WHATSAPP = 'whatsapp',
  TELEGRAM = 'telegram',
  WHATSAPP_ICON = 'whatsapp-icon',
  ARROW_RIGHT_BOLD = 'arrow-right-bold',
  CHEVRON_RIGHT = 'chevron-right',
  PLAIN_BOLD = 'plain-bold',
  AIRPLANE_BIG = 'airplane_big',
  AIRPLANE_BIG_FILLED = 'airplane_big_filled',
  FEEDBACK_HEART = 'feedback_heart',
  FOOD = 'food',
  BED = 'bed',
  FILTERS = 'filters',
  PASSENGERS_TRIO = 'passengers_trio',
  FLIGHT_TICKETS = 'flight_ticket',
  CRESCENT_MOON = 'crescent_moon',
  PLAIN_RIGHT = 'plain_right',
  PHONE = 'phone',
  MONEY = 'money',
  KYRGYZSTAN = 'kyrgyzstan',
  USER_SIMPLE = 'user_simple',
  VERIFIED = 'verified',
  HOME = 'home',
  LOCK_KEY = 'lock_key',
  CHEVRON_CELL = 'chevron_cell',
  TIME = 'time',
  CALENDAR_NEW_FILLED = 'calendar_new_filled',
  PLANNER = 'planner',
  MONEY_FILLED = 'money_filled',
  FILE_WORD = 'file_word',
  FILE_WORD_FILLED = 'file_word_filled',
  ID_CARD = 'id_card',
  MONEY_DOWN = 'money_down',
  HEADSET = 'headset',
  DOWNLOAD = 'download',
  INFO_TRIANGLE = 'info_triangle',
  DOOR_CLOSE = 'door_close',
  OPEN_BOOK = 'open_book',
  CANCEL_MONEY = 'cancel_money',
  SHIELD = 'shield',
  //
  PLANE_ACTIVE = 'plane-active',
  EXCURSIONS_ACTIVE = 'excursions-active',
  KYRGYZSTAN_ACTIVE = 'kyrgyzstan-active',
  TOUR_ACTIVE = 'tour-active',
  BUS_ACTIVE = 'bus-active',
  UMARA_ACTIVE = 'umara-active',

  PLANE_DISABLED = 'plane-disabled',
  EXCURSIONS_DISABLED = 'excursions-disabled',
  KYRGYZSTAN_DISABLED = 'kyrgyzstan-disabled',
  TOUR_DISABLED = 'tour-disabled',
  BUS_DISABLED = 'bus-disabled',
  UMARA_DISABLED = 'umara-disabled',
  PLANE_NEW = 'plane_new',
  TICKET_ALT = 'ticket_alt',
  CIRCLE_USER = 'circle_user',
  PENCIL = 'pencil',
  ID_CARD_2 = 'id_card_2',
  PASSPORT = 'passport',
  GROUP = 'group_filled',
  CHAT_FEEDBACK_FILLED = 'chat_feedback_filled',
  FAQ_FILLED = 'faq_filled',
  POLICY_FILLED = 'policy_filled',
  ARROW_RIGHT_SMALL = 'arrow_right_small',
  DANGER = 'danger',
  HEART_BIG = 'heart_big',
  FAVORITES = 'favorites',
  TRIANGLE = 'triangle',

  CHECK = 'check',
  STAR = 'star',
  LIGHT = 'light',
  LIKE_NEW = 'like_new',
  PERCENT = 'percent',
  GIFT = 'gift',
  SEATS = 'seats',
  CROSS_BOLDER = 'cross_bolder',
  PASSENGERS_BG = 'passengers_bg',
  AIRPLANE_BG = 'airplane_bg',
  LOAD_FILE = 'load-file',
  REFRESH = 'refresh',
  CIRCLE_PLUS = 'circle_plus',
  GALLERY = 'gallery',
  LOCATION = 'location',
  LEFT_ALIGNMENT = 'left_alignment',
  INFO_TRIANGLE_OUTLINED = 'info_triangle_outlined',
  PENCIL_FILLED = 'pencil_filled',
  ROUTE = 'route',
  THUMBS_UP = 'thumbs_up',
  FLAG = 'flag',
  FILE = 'file',
  INSURANCE_CALCULATION_PARTICIPANTS = 'insurance-calculation-participants',
  INSURANCE_CALCULATION_MONEY = 'insurance-calculation-money',
  CHECK_BOLD = 'check_bold',
  CONTRACT_ERROR = 'contract-error',
  DOCUMENT = 'document',
  BOOKING = 'booking',
  PLANE_DEPARTURE = 'plane-departure',
  CALENDAR_ALT = 'calendar-alt',
  COPY_ALT = 'copy-alt',
  CHEVRON_DOWN = 'chevron-down',
  EXTERNAL_LINK = 'external_link',
  ESIM = 'esim',
}
